import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({
    path: "/404",
    title: "404 · Sayfa Bulunamadı",
    description: "Aradığınız sayfa bulunamadı veya silinmiş.",
  });

  return (
    <div className="np-notfound" data-testid="notfound-page">
      <div className="np-notfound-box">
        <h1 className="np-notfound-h1">404</h1>
        <p className="np-notfound-text">Aradığınız sayfa bulunamadı veya silinmiş.</p>
        <Link to="/" className="np-notfound-cta" data-testid="notfound-home-link">
          ANA SAYFA
        </Link>
      </div>
    </div>
  );
}
